import { useContext } from "react";

import { CustomerContext } from "../context/CustomerContext";

export const useCustomerHook = () => {
  const context = useContext(CustomerContext);

  return context;
};
